/**
 * Tabela Orya com scroll nativo (horizontal/vertical) e cabeçalhos ordenáveis.
 */

import React, { memo, useCallback, useMemo, useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { sortOryaTableRows } from '../utils/relatoriosOryaTableSort';

function RelatoriosOryaScrollableTable({ header, body, renderCell, uniform = false }) {
  const [sort, setSort] = useState({ col: null, dir: 'asc' });

  const handleHeaderClick = useCallback((colIdx) => {
    setSort((prev) => {
      if (prev.col === colIdx) {
        return { col: colIdx, dir: prev.dir === 'asc' ? 'desc' : 'asc' };
      }
      return { col: colIdx, dir: 'asc' };
    });
  }, []);

  const handleHeaderKeyDown = useCallback(
    (e, colIdx) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        handleHeaderClick(colIdx);
      }
    },
    [handleHeaderClick]
  );

  const sortedBody = useMemo(() => {
    if (sort.col == null) return body;
    return sortOryaTableRows(body, sort.col, sort.dir);
  }, [body, sort.col, sort.dir]);

  return (
    <div
      className={`rel-orya-md-table-shell rel-orya-md-table-shell--headed${uniform ? ' rel-orya-md-table-shell--uniform' : ''}`}
    >
      <div className="rel-orya-md-table-wrap">
        <table className="rel-orya-md-table">
          <thead>
            <tr>
              {header.map((h, hi) => (
                <th
                  key={hi}
                  className={`rel-orya-md-table-th-sortable${sort.col === hi ? ` rel-orya-md-table-th-sortable--active rel-orya-md-table-th-sortable--${sort.dir}` : ''}`}
                  onClick={() => handleHeaderClick(hi)}
                  onKeyDown={(e) => handleHeaderKeyDown(e, hi)}
                  tabIndex={0}
                  role="columnheader"
                  aria-sort={
                    sort.col === hi ? (sort.dir === 'asc' ? 'ascending' : 'descending') : 'none'
                  }
                >
                  <span className="rel-orya-md-table-th-inner">
                    <span className="rel-orya-md-table-th-label">{renderCell(h)}</span>
                    <span className="rel-orya-md-table-sort-icon" aria-hidden>
                      {sort.col === hi ? (
                        sort.dir === 'asc' ? (
                          <ChevronUp size={10} strokeWidth={2.5} />
                        ) : (
                          <ChevronDown size={10} strokeWidth={2.5} />
                        )
                      ) : null}
                    </span>
                  </span>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sortedBody.map((row, ri) => (
              <tr key={ri}>
                {header.map((h, ci) => (
                  <td key={ci}>{renderCell(row[ci] ?? '', header[ci])}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default memo(RelatoriosOryaScrollableTable);
